<template>
  <div class="bid-box" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-box">
      <!--<div style="margin-top: 15px;">-->
        <!--<el-input placeholder="请输入招标编码/产品名称" clearable v-model="form.Keyword">-->
          <!--<el-button @click="search" slot="append" style="padding-left: 40px;padding-right: 40px;" type="primary"-->
                     <!--icon="el-icon-search">搜索-->
          <!--</el-button>-->
        <!--</el-input>-->
      <!--</div>-->
    </div>
    <div class="location">
      <p><span>当前位置</span>：招标大厅>招标详情</p>
    </div>
    <div class="bid-detail-box">
      <div class="pro-img">
        <img style="width: 100%;height: 100%;" :src="imgUrl">
      </div>
      <div class="bid-detail">
        <div style="display: flex;">
          <div class="bid-head">
            <img class="img-p" src="/static/images/bid/u56.svg">
            <p class="title">{{ form.F_ProductName }}</p>
            <p>起拍价：<span class="money">￥{{ form.F_StartPrice }}</span></p>
            <p>距离结束：<span
              style="font-size: 16px;font-weight: 600;color: #FF6633;letter-spacing: 2px">{{ time(djs) }}</span></p>
          </div>
          <!--<div class="bid-button-father" style="width: 500px;">-->
            <!--<div style="margin-bottom: 5px;">-->
              <!--<el-alert-->
                <!--:title="'温馨提示：'+mesRight"-->
                <!--type="error"-->
                <!--effect="dark">-->
              <!--</el-alert>-->
            <!--</div>-->
            <!--<el-table-->
              <!--:data="bidHistory"-->
              <!--class="table-sty"-->
              <!--height="160px"-->
              <!--v-loading="tableLoading"-->
              <!--border-->
              <!--:cell-style="cellStyleFun"-->
              <!--size="small"-->
            <!--&gt;-->
              <!--<el-table-column-->
                <!--prop="F_CreateTime"-->
                <!--header-align="center" align="center"-->
                <!--label="出价时间"-->
                <!--width="180">-->
                <!--<template slot-scope="scope">-->
                  <!--<P>{{scope.row.F_CreateTime.replace(/T/,' ')}}</P>-->
                <!--</template>-->
              <!--</el-table-column>-->
              <!--<el-table-column-->
                <!--prop="F_Price"-->
                <!--header-align="center" align="center"-->
                <!--label="出价(元/吨)"-->
                <!--width="">-->
              <!--</el-table-column>-->
              <!--<el-table-column-->
                <!--prop="F_FirstQuantity"-->
                <!--header-align="center" align="center"-->
                <!--label="申买量(吨)"-->
                <!--width="">-->
              <!--</el-table-column>-->
              <!--<el-table-column-->
                <!--prop="F_Quantity"-->
                <!--header-align="center" align="center"-->
                <!--label="有效数量(吨)"-->
                <!--width="">-->
              <!--</el-table-column>-->
            <!--</el-table>-->
            <!--&lt;!&ndash;<p style="font-size: 15px;color: red;font-weight: 600;margin-top: 10px;">您当前竞拍的中标数量为：{{AllNum}}吨</p>&ndash;&gt;-->
          <!--</div>-->
        </div>

        <div class="out-price">
          <div>
            <div class="input-p">
              <span>出价：</span>
              <input type="text" v-model="outForm.Price" placeholder="请输入价格"
                     oninput="if(isNaN(value) || value > 9999999) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+4)}" />
            </div>
            <div class="input-p">
              <span>申买量：</span>
              <input type="text" v-model="outForm.Quantity" placeholder="请输入申买量"
                     oninput="if(isNaN(value) || value > 9999999) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+2)}"></input>
            </div>
          </div>
          <div v-if="form.F_Status ==2 && form.F_IsAbandon != '1'" class="btn-out">
            <span @click="outPrice">报价</span>
          </div>
          <div v-if="form.F_Status ==2" class="btn-out" >
            <span v-if="form.F_IsAbandon == '1'" style="background: #909399">已弃标</span>
            <span v-else style="background: #F56C6C" @click="giveUp">弃标</span>
          </div>
        </div>
        <div class="detail-c">
          <div class="item-b item-b1">
            <p>招标量：<span>{{ form.F_AutionNum }}吨</span></p>
            <p>售货单位：<span>{{ form.F_WarehouseName }}</span></p>
            <p>提货日期：<span>{{ form.F_ShipmentDateStr }}</span></p>
            <!--<p v-if="form.F_AutionType == 2">最小加价幅度：<span>{{form.F_AddPrice}}</span></p>-->
          </div>
          <div class="item-b item-b2">
            <p>最小招标量：<span>{{ form.F_StartWeight }}吨</span></p>
            <!--<p>保证金：<span>请先缴纳保证金</span></p>-->
            <p>单向加价量：<span>{{form.F_AddQuantity}}</span></p>
            <p>提货地：<span>{{form.F_DeliveryPlace}}</span></p>
          </div>
          <div class="item-b item-b3">
            <p>招标时间：<span
                style="font-size: 12px">{{
                form.F_AutionStartTime ? form.F_AutionStartTime.substring(0, 10) + " " + form.F_AutionStartTime.substring(11, form.F_AutionStartTime.length) : ""
                                        }}至{{
                form.F_AutionEndTime ? form.F_AutionEndTime.substring(0, 10) + " " + form.F_AutionEndTime.substring(11, form.F_AutionEndTime.length) : ""
                                        }}</span>
            </p>
            <!--<p>单向加价量：<span>{{form.F_AddQuantity}}</span></p>-->
            <p v-if="form.F_AutionType == 2">最小加价幅度：<span>{{form.F_AddPrice}}</span></p>
          </div>
        </div>
        <div style="padding-left:25px;display: flex;align-items: center;font-size: 14px">
          <p style="width: 80px;">备注说明：</p><span style="font-size: 18px;font-weight: 600;color: #0441A0;flex: 1;">{{form.F_AutionDepiction}}</span>
        </div>
      </div>
    </div>
    <div class="tab-box">
      <ul>
        <li v-for="(item,index) in tabs" :key="index" :class="{activeLi:item.isActive}" @click="changeTab(item)">
          {{ item.text }}
        </li>
      </ul>
    </div>
    <div>
      <div v-if="whichTab == 1" style="background: #f5f5f5;padding: 20px 10px 50px 10px;">
        <div v-if="form.F_ProductNewShow" v-html="form.F_ProductNewShow">

        </div>
        <div v-else>
          <p style="text-align: center"><img src="/static/images/bid/u476.png"></p>
          <p style="font-size: 18px;font-weight: 600;text-align: center;margin-top: 10px;color: #888888;">暂无数据</p>
        </div>
      </div>
      <div v-else-if="whichTab == 2" style="padding: 30px 0px;">
        <el-table
            :data="bidHistory"
            stripe
            v-loading="tableLoading"
            style="width: 100%">

          <el-table-column
              prop="F_CreateTime"
              align="center"
              header-align="center"
              label="出价时间"
          >
            <template slot-scope="scope">
              {{ scope.row.F_CreateTime |dateNoT }}
            </template>
          </el-table-column>
          <el-table-column
              prop="F_FirstQuantity"
              align="center"
              header-align="center"
              label="申买量">
          </el-table-column>

          <el-table-column
              prop="F_Price"
              align="center"
              header-align="center"
              label="报价">
          </el-table-column>
          <el-table-column
            prop="F_FinalPrice"
            align="center"
            header-align="center"
            label="最终成交单价">
          </el-table-column>
          <el-table-column
              prop="address"
              align="center"
              header-align="center"
              label="公示结果">
            <template slot-scope="scope">
              <div v-if="scope.row.F_DeleteMark">
                <el-tag type="danger" effect="dark">失效</el-tag>
              </div>
              <div v-else>
                <el-tag v-if="scope.row.F_WinType == -1" effect="dark">未投标</el-tag>
                <el-tag v-if="scope.row.F_WinType == 2" type="success" effect="dark">已中标</el-tag>
                <el-tag v-if="scope.row.F_WinType == 1" type="danger" effect="dark">未中标</el-tag>
                <el-tag v-if="scope.row.F_WinType == 3" type="" effect="dark">公示中</el-tag>
                <el-tag v-if="scope.row.F_WinType == 4" type="info" effect="dark">招标进行中</el-tag>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else-if="whichTab == 3" style="padding: 30px 0px;">
        <el-table
          :data="bidMax"
          stripe
          v-loading="tableLoading"
          style="width: 100%">
          <!--<el-table-column-->
          <!--prop="nums"-->
          <!--align="center"-->
          <!--header-align="center"-->
          <!--label="报价次数"-->
          <!--&gt;-->
          <!--</el-table-column>-->
          <el-table-column
            prop="F_CreateTime"
            align="center"
            header-align="center"
            label="出价时间"
          >
            <template slot-scope="scope">
              {{ scope.row.F_CreateTime |dateNoT }}
            </template>
          </el-table-column>
          <!--<el-table-column-->
            <!--prop="F_Quantity"-->
            <!--align="center"-->
            <!--header-align="center"-->
            <!--label="申买量">-->
          <!--</el-table-column>-->
          <el-table-column
            prop="F_Price"
            align="center"
            header-align="center"
            label="当前最高价">
          </el-table-column>
          <!--<el-table-column-->
            <!--prop="address"-->
            <!--align="center"-->
            <!--header-align="center"-->
            <!--label="公示结果">-->
            <!--<template slot-scope="scope">-->
              <!--<div v-if="scope.row.F_DeleteMark">-->
                <!--<el-tag type="danger" effect="dark">失效</el-tag>-->
              <!--</div>-->
              <!--<div v-else>-->
                <!--<el-tag v-if="scope.row.F_WinType == -1" effect="dark">未投标</el-tag>-->
                <!--<el-tag v-if="scope.row.F_WinType == 2" type="success" effect="dark">已中标</el-tag>-->
                <!--<el-tag v-if="scope.row.F_WinType == 1" type="danger" effect="dark">未中标</el-tag>-->
                <!--<el-tag v-if="scope.row.F_WinType == 3" type="" effect="dark">公示中</el-tag>-->
                <!--<el-tag v-if="scope.row.F_WinType == 4" type="info" effect="dark">招标进行中</el-tag>-->
              <!--</div>-->
            <!--</template>-->
          <!--</el-table-column>-->
        </el-table>
      </div>
    </div>
    <!--    弹窗-->
    <div>
      <el-dialog center :close-on-click-modal="false"
                 title="招标规则"
                 :visible.sync="dialogVisible">
        <p class="data">1、您如果想参与此次招标请在招标开始前线下缴纳保证金（详见招标公告）并第一时间通知销售经理您参与此次招标。</p>
        <p class="data"> 2、招标开始后点击参与招标，在招标时间范围内：</p>
        <p class="data" style="padding-left: 15px"> a.您可以不进行出价，视同您放弃此次招标。</p>
        <p class="data" style="padding-left: 15px">b.您可以只出价一次，此出价为有效出价，并以您此次出价为最终出价。</p>
        <p class="data" style="padding-left: 15px">c.您可多次进行出价，系统以您最后一次出价为最终出价（最后一次出价之前的价格系统视同为无效出价）。</p>
        <p class="data" style="padding-left: 15px">d.您可以在参与过程中弃标，弃标需填写您的弃标原因，您一旦确定弃标后您所有出价将作废，且不能再参与此次招标。</p>
        <p class="data">3、招标结束后系统会依据您最终出价确定是否中标（出价最高者中标，相同价格时出价早者中标），中标后销售经理会与您联系。</p>
<!--        <p class="data" style="text-align: center;font-weight: bold">招标结果系统会以出价最高者中标！！！</p>-->
        <span slot="footer" class="dialog-footer">
          <el-button type="warning" @click="CloseIt" :class="{disabled: !this.canClick}">{{ content }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        F_Id: "",
        F_StartPrice: "",
        F_ProductName: "",
        F_ProductImgUrl: "",
        F_AutionNum: "",
        F_StartWeight: "",
        F_WarehouseName: "",
        F_ProductNewShow: "",
        F_AutionStartTime: "",
        F_AutionEndTime: "",
        F_Status: null,//竞拍状态 0待发布 1未开始 2已开始 3已完成 4公示中
        F_AutionEndTimeStr: "",
        F_AutionType:'',//竞拍类型1普通竞拍2阶梯竞拍
        F_AddPrice:'',//加价幅度
        F_IsAbandon:'',//是否弃标1是
        F_AddQuantity:'',
        F_IsHGP:null,
        F_ShipmentDateStr:'',
        F_DeliveryPlace:'',
        F_AutionDepiction:'',
      },
      fullscreenLoading:false,
      outForm: {
        AuctionId: "",
        Price: "",
        Quantity: ""
      },
      bidList: [],
      tableLoading: false,
      dialogVisible: true,
      canClick: true,
      content: "",
      totalTime: 3,
      PageIndex: 1,
      url: {
        GetAuctionInfo: SZH.assets.api + "/Auction/GetAuctionInfo",
        AuctionAbandon: SZH.assets.api + "/Auction/AuctionAbandon",
        GetPagingActionProcessByCustom: SZH.assets.api + "/Auction/GetPagingActionProcessByCustom",
        SumbitPrice: SZH.assets.api + "/Auction/SumbitPrice",
        GetCurrentDateTime: SZH.assets.api + "/Custom/GetCurrentDateTime",
        GetPagingActionProcessMax: SZH.assets.api + "/Auction/GetPagingActionProcessMax",
        GetPagingActionProcessMax2: SZH.assets.api + "/Auction/GetPagingActionProcessMax2",

      },
      currentpage: 1,
      TotalCount: 0,
      pageSize: 20,
      tabs: [
      ],
      bidMax:[],
      whichTab: 2,
      bidHistory: [],
      BidId: "",
      ticker: null,
      djs: "",
      TimeCount: "",
      currentTime: "",
      imgUrl: "",
      MyPriceList:[],
      mesRight:'',
    }
  },
  created(){
    this.connectServer();
  },
  methods: {
    cellStyleFun({row, column, rowIndex, columnIndex}) {
      if(column.property == 'F_Quantity'){
        return {color: 'red',fontWeight:600}
      }
    },
    connectServer() {
      var $this = this;
      // $this.proxy = $this.sg.SR.createHubProxy("NoticeHub");
      // $this.toGetMEs();
      // $this.sg.SR.start().done((connection) => {
      //   console.log("signaR连接成功");
      // }).fail((data) => {
      // });
      var conn = $.hubConnection(SZH.assets.ws, {});
      $this.proxy = conn.createHubProxy("NoticeHub");
      $this.toGetMEs();
      conn.start().done((connection) => {
        // $this.sendMsg();
        $this.ClientId = connection.id;
      }).fail((data) => {
      });
    },
    toGetMEs() {
      var $this = this;
      $this.proxy.on("receiveNotice", (data) => {
        $this.mesRight = data;
        console.log(data);
        if(data){
          $this.geyMyPrice();
          $this.getcuttent();
        }
      });
    },
    giveUp(){
      this.$prompt('请输入弃标原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        inputType:'textarea',
        inputPattern:/\S/,
        inputErrorMessage:'请输入原因'
      }).then(({ value }) => {
        this.$http.post(this.url.AuctionAbandon, {
          keyValue:{
            AuctionId:this.BidId,
            Reason:value
          }
        }).then(result => {
          if (result.state == true) {
            this.$message.success("弃标成功!");
            this.getcuttent();
          } else {
            this.$message.error(result.message);
          }
        }, () => {
          this.$message.error("数据保存失败，请检查您的网络是否可用。");
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    // getPic() {
    //   if (this.form.F_ProductImgUrl) {
    //     return SZH.assets.image + "/" + this.form.F_ProductImgUrl;
    //   } else {
    //     return "";
    //   }
    // },
    onCurrentChange() {
    },
    changeTab(it) {
      let self = this;
      self.whichTab = it.index;
      self.tabs.forEach(item => {
        item.isActive = false;
        if (it.text == item.text) {
          item.isActive = true;
        }
      });
      if (self.whichTab == 2) {
        self.geyMyPrice();
      }
      if (self.whichTab == 3) {
        self.getBidMax();
      }
    },
    outPrice() {
      let self = this;
      if (!self.outForm.Price) {
        self.$message.error("请输入价格");
        return
      }
      if(self.outForm.Price <= 0){
        self.$message.error("报价必须大于0元");
        return;
      }
      if (self.outForm.Price < self.form.F_StartPrice) {
        self.$message.error("价格不能小于起拍价");
        return
      }
      if (!self.outForm.Quantity) {
        self.$message.error("请输入申买量");
        return
      }
      if (self.outForm.Quantity < self.form.F_StartWeight) {
        self.$message.error("申买量不能小于最小招标量");
        return
      }
      if (self.outForm.Quantity > self.form.F_AutionNum) {
        self.$message.error("申买量不能大于招标量");
        return
      }
      let maxPrice = '';
      self.$http.post(self.url.GetPagingActionProcessMax2, {
        AuctionId: self.BidId
      }).then(result => {
        if (result.state == true) {
          maxPrice = result.data.F_Price;
          let cutNum = (self.outForm.Price - maxPrice).toFixed(2);
          if(cutNum > 0){
            self.$confirm(`您当前报价高于最高价 【${cutNum}】 元。确认即生效，产生法律效力。请注意： 一旦确认，不可撤销。若中标后弃标，一切不利后果（含经济赔偿与信用损失）由您全权自负。是否继续?`, '郑重警示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              center:true,
              type: 'warning'
            }).then(() => {
              self.outPriceFinal();
            }).catch(() => {
              self.$message({
                type: 'info',
                message: '已取消出价'
              });
            });
          }else{
            self.outPriceFinal();
          }

        } else {
        }
      }, () => {
        self.$message.error("数据保存失败，请检查您的网络是否可用。");
      });

    },
    outPriceFinal(){
      let self = this;
      self.fullscreenLoading =true;
      self.$http.post(self.url.SumbitPrice, self.outForm).then(result => {
        if (result.state == true) {
          self.$message.success("出价成功!");
          self.geyMyPrice();
        } else {
          self.$message.error(result.message);
        }
        self.fullscreenLoading =false;
      }, () => {
        self.fullscreenLoading =false;
        self.$message.error("数据保存失败，请检查您的网络是否可用。");
      });
    },
    getBid() {
      let self = this;
      self.$http.post(self.url.GetAuctionInfo, {
        keyValue: self.BidId
      }).then(result => {

        if (result.state == true) {
          self.form = result.data;
          if(self.form.F_IsHGP){
            let arr = [
              {
                isActive: true,
                text: "我的报价",
                index: 2
              },
              {
                isActive: false,
                text: "产品详情",
                index: 1
              },
              {
                isActive: false,
                text: "当前最高价",
                index: 3
              }
            ];
            self.tabs = arr
          }else{
            self.tabs = [
              {
                isActive: true,
                text: "我的报价",
                index: 2
              },
              {
                isActive: false,
                text: "产品详情",
                index: 1
              },
            ];
          }
          self.imgUrl = self.form.F_ProductImgUrl ? SZH.assets.image + "/" + self.form.F_ProductImgUrl : "";
          //  开始准备倒计时
          if (self.ticker) {
            //这一段是防止进入页面出去后再进来计时器重复启动
            clearInterval(self.ticker);
          }
          self.beginTimer();
        } else {
          self.form = {};
          self.$message.error(result.message);
        }

      }, () => {
        self.$message.error("数据保存失败，请检查您的网络是否可用。");
      });
    },
    getBidMax() {
      let self = this;
      self.tableLoading = true;
      self.$http.post(self.url.GetPagingActionProcessMax, {
        PageSize: 100,
        PageIndex: self.PageIndex,
        Data: {
          AuctionId: self.BidId
        }

      }).then(result => {
        if (result.state == true) {

          self.bidMax = result.data
        } else {
          self.bidMax = [];
          // self.$message.error(result.message?result.message:'未查询到数据')
          // self.$message.error(result.message);
        }
        self.tableLoading = false;
      }, () => {
        self.tableLoading = false;
        self.$message.error("数据保存失败，请检查您的网络是否可用。");
      });
    },
    beginTimer() {
      let self = this;
      self.djs = new Date(self.form.F_AutionEndTimeStr).getTime() - new Date(self.currentTime).getTime();
      //这个计时器是每秒减去数组中指定字段的时间
      self.ticker = setInterval(() => {
        self.djs = self.djs - 1000;
        if(self.djs == 0){
          self.$router.push({
            path: '/Menu/AuctionHallList',
          })
        }
      }, 1000);
    },
    time(time) {
      //这个函数是每秒把时间重新计算下
      if (time >= 0) {
        let d = Math.floor(time / 1000 / 60 / 60 / 24);
        let h = Math.floor((time / 1000 / 60 / 60) % 24);
        let m = Math.floor((time / 1000 / 60) % 60);
        let s = Math.floor((time / 1000) % 60);
        return d + "天" + h + "时" + m + "分" + s + "秒";
      } else {
        return "已结束"
      }
    },
    geyMyPrice() {
      let self = this;
      self.tableLoading = true;
      self.$http.post(self.url.GetPagingActionProcessByCustom, {
        PageSize: 100,
        PageIndex: self.PageIndex,
        Data: {
          AuctionId: self.BidId
        }

      }).then(result => {
        if (result.state == true) {

          self.bidHistory = result.data.Data
        } else {
          self.bidHistory = [];
          // self.$message.error(result.message?result.message:'未查询到数据')
          // self.$message.error(result.message);
        }
        self.tableLoading = false;
      }, () => {
        self.tableLoading = false;
        self.$message.error("数据保存失败，请检查您的网络是否可用。");
      });
    },
    handTab() {
      let that = this;
      that.PageIndex = 1;
    },
    search() {
    },
    getcuttent() {
      let self = this;
      self.$http.post(self.url.GetCurrentDateTime, {}).then(result => {
        if (result.state == true && result.data) {
          self.currentTime = result.data;
          self.getBid();
        } else {
        }
      }, () => {
        self.$message.error("数据保存失败，请检查您的网络是否可用。");
      });
    },
    CloseIt() {
      if (!this.canClick) {
        return
      } else {
        this.dialogVisible = false
      }
    },
    CountDown() {
      if (!this.canClick) return  //改动的是这两行代码
      this.canClick = false
      this.content = this.totalTime + "s后可点击"
      let clock = window.setInterval(() => {
        this.totalTime--
        this.content = this.totalTime + "s后可点击"
        if (this.totalTime < 0) {
          window.clearInterval(clock)
          this.content = "我已知晓"
          this.totalTime = 10
          this.canClick = true  //这里重新开启
        }
      }, 1000)
    }
  },
  destroyed() {
  },
  computed: {},
  components: {},
  mounted() {
    this.BidId = this.$route.query.id;
    this.outForm.AuctionId = this.$route.query.id;
    this.CountDown();
    this.getcuttent();
    this.geyMyPrice();
  }
}
</script>
<style type="text/css" src="./AuctionHallDetail.css" scoped></style>
<style scoped>
.disabled {
  background-color: grey;
  border-color: #ddd;
  color: #ffffff;
  cursor: not-allowed;
}
.data{
  font-size: 16px;
  font-weight:400;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/AuctionHall/AuctionHallDetail/AuctionHallDetail.vue